<template>
  <div >
    <b-container fluid>
      <b-row>
          <b-col>
            <b-button variant="success" @click="showModal('modal-createfile')">Mitarbeiter Datei anlegen</b-button>
          </b-col>
           <b-col>
            <b-button variant="primary" @click="refresh()">Aktualisieren</b-button>
          </b-col>
      </b-row>
      <br>
       <b-row v-if="files != undefined">
          <b-col>
            <b-table bordered :items="files" :fields="fields">
                <template slot="link" slot-scope="row">
                   <a :href="row.item.url+'/api/file?id='+row.item.fileId+'&accessToken='+row.item.accessToken">Link</a>
                </template>
                <template slot="actions" slot-scope="row">
                    <b-button class="mx-1" size="sm" v-on:click="openEditModal(row)"><i class="fas fa-pencil-alt"></i></b-button>
                    <b-button class="mx-1" size="sm" variant="danger" v-on:click="openDeleteModal(row)"><i class="fas fa-trash"></i></b-button>
                </template>
            </b-table>
          </b-col>
      </b-row>
      
    </b-container>

    <b-modal ref="modal-createfile"  no-close-on-backdrop no-close-on-esc centered title="Datei anlegen" @cancel="hideModal('modal-createfile')" @ok="createFile" cancel-title="Abbrechen">
        <b-container fluid>
            <div>

                <b-form-group label-cols="4" label-cols-lg="2" label="Datei" label-for="file">
                    <b-form-file id = "file" accept="image/jpeg, image/png, application/pdf" placeholder="Datei auswählen..." v-model="employeeFile.upload" ref="file-input" class="mb-2"></b-form-file>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Name" label-for="filename">
                    <b-form-input id="filename" v-model="employeeFile.name"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Bereich" label-for="documenttype">
                    <b-form-select id = "documenttype" v-model="employeeFile.documentType">
                        <option key = "1" value = "CONTRACT">
                            Arbeitsvertrag
                        </option>
                        <option key = "2" value = "ID">
                            Ausweis
                        </option>
                        <option key = "3" value = "DRIVERSLICENSE">
                            Führerschein
                        </option>
                        <option key = "4" value = "REGISTRATION">
                            Meldezettel
                        </option>
                        <option key = "5" value = "MISC">
                            Sonstiges
                        </option>
                    </b-form-select>
                </b-form-group>

                
            </div>
            
            <b-row v-if="fileerror">
                Fehler beim Erstellen der Datei.
            </b-row>
        </b-container>
    </b-modal>
    <b-modal ref="modal-editfile"  no-close-on-backdrop no-close-on-esc centered title="Datei bearbeiten" @cancel="hideModal('modal-editfile')" @ok="editFile" cancel-title="Abbrechen">
        <b-container fluid>
            <div>
                <b-form-group label-cols="4" label-cols-lg="2" label="Name" label-for="filename">
                    <b-form-input id="filename" v-model="employeeFile.name"></b-form-input>
                </b-form-group>
                <b-form-group label-cols="4" label-cols-lg="2" label="Bereich" label-for="documenttype">
                    <b-form-select id = "documenttype" v-model="employeeFile.documentType">
                        <option key = "1" value = "CONTRACT">
                            Arbeitsvertrag
                        </option>
                        <option key = "2" value = "ID">
                            Ausweis
                        </option>
                        <option key = "3" value = "DRIVERSLICENSE">
                            Führerschein
                        </option>
                        <option key = "4" value = "REGISTRATION">
                            Meldezettel
                        </option>
                        <option key = "5" value = "MISC">
                            Sonstiges
                        </option>
                    </b-form-select>
                </b-form-group>
            </div>
            
            <b-row v-if="fileerror" class="my-1">
                Fehler beim Bearbeiten der Datei.
            </b-row>
        </b-container>
    </b-modal>
    <b-modal ref="modal-deletefile"  no-close-on-backdrop no-close-on-esc centered title="Datei löschen" @cancel="hideModal('modal-deletefile')" @ok="deleteFile" cancel-title="Abbrechen">
        <b-container fluid>
            <b-row class="my-1">
                <p> Sind Sie sicher dass Sie die Datei löschen wollen?</p>
            </b-row>
            <b-row v-if="fileerror" class="my-1">
                Fehler beim Löschen der Datei.
            </b-row>
        </b-container>
    </b-modal>

  </div>

</template>

<script>

export default {
  name: 'employeefiles',
  props: ["employeeId"],
  data () {
    return {
      fileMap: {},
      files: [],
      fields: [{key:"name", sortable: true},{key:"creationDate", label:"Erstell Datum", sortable: true}, {key:"documentType", label:"Datei Typ", sortable: true}, {key:"link", label: "Link"},{key:"actions", sortable: false}],
      employeeFile: {
            name: "",
            documentType: "CONTRACT",
            upload: null, 
      },
      
      fileId:"",
      currentrow: {},
      fileerror: false,
    }
  },
  created: function () {
    
        this.refresh();
    
  },
  // methods that implement data logic.
  methods: {
    refresh: function() {
        let view = this;
        view.loadFiles()
        .then(response => {
            view.updateFiles(response.data);
        }).catch(function (error) {
             console.log(error)
        });
    },
    createFile: function(evt){
        evt.preventDefault();
        this.fileerror=false;
        let view = this;
        let url = '/api/sec/employeefile/upload';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeefile/upload');
        
        let formData = new FormData();
        formData.append("employeeId", this.$props.employeeId);
        formData.append("name", this.employeeFile.name);
        formData.append("documentType", this.employeeFile.documentType);
        formData.append('file', this.employeeFile.upload);
   
        this.axios({
            method: 'post',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: formData
        }).then(response => {
            let file = response.data.data;
            view.fileMap[file.id] = file;
            view.files.push(file);
            
            view.hideModal('modal-createfile');
        }).catch(function (error) {
            view.fileerror=true;
            console.log(error)
        })

    },
    openEditModal: function(row){
        this.currentrow = row;
        this.employeeFile ={
          name: row.item.name,
          documentType: row.item.documentType,
          
        };
        this.fileId = row.item.id;
        this.showModal('modal-editfile');
    },
    editFile: function(evt){
        evt.preventDefault();
        this.fileerror=false;
        let view = this;
        let url = '/api/sec/employeefile';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeefile');
        
        let payload = {
            id: this.fileId,
            name: this.employeeFile.name,
            documentType: this.employeeFile.documentType,
            updateFields: ["name", "documentType"]
        }

        this.axios({
            method: 'put',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            view.currentrow.item.name=view.employeeFile.name;
            view.currentrow.item.documentType = view.employeeFile.documentType;
            view.hideModal('modal-editfile');
        }).catch(function (error) {
            view.fileerror=true;
            console.log(error)
        })

    },
    openDeleteModal: function(row){
        this.currentrow = row;
        this.fileId = row.item.id;
        this.showModal('modal-deletefile');
    },
    deleteFile: function(evt){
        evt.preventDefault();
        this.fileerror=false;
        let view = this;
        let url = '/api/sec/employeefile';
        
        url = this.$helpers.appendParam("id", this.fileId, url, '/api/sec/employeefile');
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeefile');
        
        
        this.axios({
            method: 'delete',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).then(response => {
            const index = this.files.findIndex(file => file.id === view.fileId) // find the filesinessunit index 
            if (~index) {
                view.files.splice(index, 1);
            }     
            view.hideModal('modal-deletefile');
        }).catch(function (error) {
            view.fileerror=true;
            console.log(error)
        })

    },
    loadFiles : function() {
      let view = this;
      let url = '/api/sec/employeefile';
      
      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeefile');
      url = this.$helpers.appendParam("employeeId", this.$props.employeeId, url, '/api/sec/employeefile');

      return this.axios({
        method: 'get',
        headers: {
            'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url
      })
			
    },
    updateFiles: function(data) {
        let overviewA = [];
        let fileM = {};
        var i;
        for (i = 0; i < data.length; i++) { 
            
            fileM[data[i].id] = data[i];
            overviewA.push(data[i]);
        }
        this.fileMap = fileM;
        this.files = overviewA;
    },
    hideModal (ref) {
        this.fileerror=false;
        this.fileId="";
        this.employeeFile ={
            name: "",
            documentType: "CONTRACT",
            upload: null,
        },
        this.currentrow={};
        
        this.$refs[ref].hide()
    },
    showModal(ref) {
        this.$refs[ref].show()
    }
  },
  components: {
  },
  computed: {
   
  },
  watch: { 
    
  } 

}
</script>

<!-- Add "scoped" attrifilete to limit CSS to this component only -->
<style scoped>

</style>
